import { initContentToc } from "./content-toc";
import { initFloatSidebars } from "./float-sidebar";
import { initLightGalleries } from "./lightgallery";
import { initSwipers } from "./swiper";
import { initFormHandlers } from "./forms"; 
import { initAccordion } from "./accordion";
import { initHeader } from "./header";
import { initBootstrapCollapse } from "./bootstrap";
import { initBootstrapModal } from "./bootstrap";
import { initBootstrapTabs } from "./bootstrap";
import { initBootstrapTooltips } from "./bootstrap";
import { initBootstrapToasts } from "./bootstrap";
import { initBootstrapPlaceholders } from "./placeholders";
import { initHomepageGoals } from "./homepage-goals";
import { initProductSharePopup } from "./product-share-popup";
import { initHomepageBlog } from "./homepage-blog";
import { initGoToTop } from "./go-to-top";
import { initAIInfo } from "./ai-info";

const initAll = () => {
  initHeader();
  initContentToc();
  initFloatSidebars();
  initLightGalleries();
  initSwipers();
  initFormHandlers();
  initAccordion();
  initBootstrapCollapse();
  initBootstrapModal();
  initBootstrapTabs();
  initBootstrapTooltips();
  initBootstrapToasts();
  initBootstrapPlaceholders();
  initHomepageGoals();
  initProductSharePopup();
  initHomepageBlog();
  initGoToTop();
  initAIInfo();
};

const setup = () => {
  if (typeof document === "undefined") return;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
    return;
  }

  initAll();
};

setup();
window.addEventListener("inkosporb2c:homepage-blog-updated", (event: Event) => {
  const root = (event as CustomEvent<{ root?: ParentNode }>).detail?.root;

  if (!root) return;

  initSwipers(root);
});
export { initHeader };
export { initContentToc };
export { initFloatSidebars };
export { initLightGalleries };
export { initSwipers };
export { initFormHandlers };
export { initBootstrapCollapse };
export { initBootstrapModal };
export { initBootstrapTabs };
export { initBootstrapTooltips };
export { initBootstrapToasts };
export { initHomepageGoals };
export { initProductSharePopup };
export { initHomepageBlog };
export { initGoToTop };
export { initAIInfo };
export const isPatternlabWebpackReady = true;
